export default __webpack_public_path__ + "static/4-fe5b726b120cc4f34e5e492844726737.png";